import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  makeStyles,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Popper,
  Hidden,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import flt from "../assets/images/flt.png";
import { useDispatch, useSelector } from "react-redux";
import DateRangeNew from "../components/reusableComponents/DateRangeNew";
import BodyText from "../components/reusableComponents/BodyText";
import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import {
  SearchReturnFormDispatch,
  SearchFormDispatch,
  fetchCityDispatch,
  SearchEtravFormDispatch,
  SearchTripjackFormDispatch,
  SearchReturnEtravFormDispatch,
  AddSearchFlightDispatch,
} from "../reducers/HomeReducer";
import Typed from "typed.js";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import DesktopDateNew from "../components/reusableComponents/DesktopDateNew";
import { setSelectedDepart, setSelectedOrigin } from "../reducers/UiReducer";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      "& div": {
        "& div": {
          display: "none",
        },
      },
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
    "& input": {
      fontSize: 14,
      fontWeight: 600,
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },

    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-184whfw-MuiAutocomplete-root .MuiAutocomplete-inputRoot":
      {
        paddingRight: 0,
      },
    // '& div': {
    // 	'& div': {
    // 		'& div': {
    // 			paddingRight: 0,
    // 		},
    // 	},
    // },
  },
  radio: {
    "& .MuiRadio-root": {
      color: "white",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "white",
      fontSize: "18px",
      fontWeight: 800,
    },
  },
  radio2: {
    "& .MuiRadio-root": {
      color: "black",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "black",
      fontSize: "14px",
      // fontWeight: 800,
    },
  },
  popper: {
    "& .MuiAutocomplete-listbox": {
      "& :hover": {
        color: "rgb(239, 51, 57)",
        // '& img': {
        // 	background: 'rgb(239, 51, 57)',
        // },
      },
    },
  },
}));
const SearchFlight = () => {
  const [result, setResult] = useState([]);
  const [result2, setResult2] = useState([]);
  const classes = useStyles();
  const { city } = useSelector((state) => state.home);
  const { agentlogin } = useSelector((state) => state.user);
  const handleRadio = (event) => {
    setValue(event.target.value);
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);
  const [infant, setInfant] = useState(0);
  const [total, SetTotal] = useState(adult + child + infant);
  const [value, setValue] = useState("Economy");
  const [leaving, setLeaving] = useState("DEL");
  const [trip, setTrip] = useState("oneway");
  const [going, setGoing] = useState("CCU");
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const { origin, depart, OriginO, selectedOrigin, selectedDepart } =
    useSelector((state) => state.ui);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  // const el = React.useRef(null);
  // // Create reference to store the Typed instance itself
  // const typed = React.useRef(null);
  // React.useEffect(() => {
  // 	const options = {
  // 		strings: ['Book Flights And Explore The World With Us'],
  // 		typeSpeed: 50,
  // 		backSpeed: 50,
  // 		// loop: true,
  // 	};

  // 	// elRef refers to the <span> rendered below
  // 	typed.current = new Typed(el.current, options);

  // 	// return () => {
  // 	// 	// Make sure to destroy Typed instance during cleanup
  // 	// 	// to prevent memory leaks
  // 	// 	typed.current.destroy();
  // 	// };
  // }, []);
  // console.log('total', adult + child + infant);
  // console.log('Adult', adult);
  // console.log('Child', child);
  // console.log('Infant', infant);
  const handleSubmit = (data) => {
    // console.log(data);
    let org = data.Origin;
    let des = data.Destination;
    let formData = {
      AdultCount: adult,
      ChildCount: child,
      InfantCount: infant,
      DirectFlight: false,
      OneStopFlight: false,
      JourneyType: 1,
      PreferredAirlines: null,
      Segments: [
        {
          Origin: from.airport_code,
          Destination: to.airport_code,
          FlightCabinClass: 1,
          PreferredDepartureTime: origin,
          // PreferredArrivalTime: '2022-03-18',
        },
        // {
        // 	Origin: 'CCU',
        // 	Destination: 'DEL',
        // 	FlightCabinClass: 1,
        // 	PreferredDepartureTime: '2022-03-18',
        // 	// PreferredArrivalTime: '2022-03-18',
        // },
      ],
      Sources: "WEB",
      agent_id: agentlogin
        ? agentlogin.status === 200
          ? agentlogin?.result.result.id
          : 0
        : 0,
      // agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
    };
    let formData2 = {
      AdultCount: adult,
      ChildCount: child,
      InfantCount: infant,
      DirectFlight: false,
      OneStopFlight: false,
      JourneyType: 2,
      PreferredAirlines: null,
      Segments: [
        {
          Origin: data.Origin,
          Destination: data.Destination,
          FlightCabinClass: 1,
          PreferredDepartureTime: origin,
          // PreferredArrivalTime: '2022-03-18',
        },
        {
          Origin: data.Destination,
          Destination: data.Origin,
          FlightCabinClass: 1,
          PreferredDepartureTime: depart,
          // PreferredArrivalTime: '2022-03-18',
        },
      ],
      Sources: "WEB",
      agent_id: agentlogin
        ? agentlogin.status === 200
          ? agentlogin?.result.result.id
          : 0
        : 0,
    };
    if (trip === "oneway") {
      // dispatch(
      // 	SearchEtravFormDispatch(formData, history, OriginO, des, origin)
      // );
      // dispatch(SearchFormDispatch(formData, history, OriginO, des, origin));
      // dispatch(AddSearchFlightDispatch(formData));
      history.push({
        pathname: `/oneway/${from.airport_code}/${to.airport_code}/${origin}`,
        state: {
          body: formData,
          OriginO: OriginO,
        },
      });

      // dispatch(
      // 	SearchTripjackFormDispatch(formData, history, OriginO, des, origin)
      // );
    } else {
      history.push({
        pathname:
          selectedOrigin.country_code === "IN" &&
          selectedDepart.country_code === "IN"
            ? `/roundway/${data.Origin}/${data.Destination}/${origin}/${data.Destination}/${data.Origin}/${depart}`
            : "/international",
        state: { returnBody: formData2 },
      });
      // dispatch(
      //   SearchReturnFormDispatch(
      //     formData2,
      //     history,
      //     selectedOrigin,
      //     selectedDepart
      //   )
      // );
      // dispatch(
      //   SearchReturnEtravFormDispatch(
      //     formData2,
      //     history,
      //     selectedOrigin,
      //     selectedDepart
      //   )
      // );
      // dispatch(AddSearchFlightDispatch(formData));
      // console.log(formData2);
    }
  };
  // console.log(invoiceOptions);
  const handleSearchOrigin = (event) => {
    let value = event.target.value.toLowerCase();
    // console.log(value);
    let cityData = {
      keywords: value,
      limits: 10,
    };
    dispatch(fetchCityDispatch(cityData, setResult));
  };
  const handleChangeTrip = (e) => {
    // console.log(e.target.value);
    dispatch(setTrip(e.target.value));
  };
  useEffect(() => {
    let cityData = {
      keywords: "bo",
      limits: 8,
    };
    dispatch(fetchCityDispatch(cityData, setResult));
  }, []);
  const PopperMy = function (props) {
    return (
      <Popper
        {...props}
        style={styles.popper}
        className={classes.popper}
        placement="bottom-start"
      />
    );
  };

  const styles = (theme) => ({
    popper: {
      width: "fit-content",
    },
  });
  return (
    <>
      <Formik
        initialValues={{
          Origin: "",
          Destination: "",
        }}
        validate={(values) => {
          const errors = {};
        }}
        onSubmit={handleSubmit}
      >
        {({ submitForm, isSubmitting, setFieldValue, values }) => (
          <>
            <Form style={{ marginTop: matches ? 100 : 180 }}>
              {/* <marquee>
								<p
									style={{
										color: 'white',
										fontSize: 36,
										// backgroundColor: 'black',
									}}
									ref={el}></p>
							</marquee> */}
              <Hidden only={["xs", "sm"]}>
                <marquee>
                  <p
                    style={{
                      color: "white",
                      fontSize: 36,
                      // backgroundColor: 'black',
                    }}
                  >
                    Book Flights And Explore The World With Us
                  </p>
                </marquee>
              </Hidden>
              <Box className={classes.radio}>
                <FormControl onChange={handleChangeTrip}>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="oneway"
                      control={
                        <Radio checked={trip == "oneway" ? true : false} />
                      }
                      label="ONE WAY"
                    />
                    <FormControlLabel
                      value="roundtrip"
                      control={
                        <Radio checked={trip == "roundtrip" ? true : false} />
                      }
                      label="ROUND TRIP"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ marginTop: 10 }}
              >
                <Grid item xs={12} md={12} lg={trip == "roundtrip" ? 4 : 5}>
                  <Grid container alignItems="center">
                    {/* Date Picker Starting */}
                    <Grid
                      item
                      xs={12}
                      lg={6}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div className={classes.root} style={{ width: "100%" }}>
                        <span style={{ color: "white" }}>Leaving From</span>
                        <Autocomplete
                          id="country-select-demo"
                          sx={{
                            background: "#eee",
                            borderRadius: "4px",
                            padding: "10px",
                            transition: "none",
                          }}
                          clearOnBlur={true}
                          value={from}
                          PopperComponent={PopperMy}
                          options={
                            city && city.result.length > 0 ? city.result : []
                          }
                          filterOptions={(options, state) => options}
                          autoHighlight
                          getOptionLabel={(option) =>
                            `${option.airport_name} (${option.airport_code}) `
                          }
                          renderOption={(props, option) => (
                            <Box
                              // mr={'5px'}
                              component="li"
                              sx={{ "& > img": { mr: 2 } }}
                              {...props}
                            >
                              <img loading="lazy" width="20" src={flt} alt="" />
                              <p style={{ fontSize: 13 }}>
                                {option.city_name} ({option.airport_code}){" "}
                                {option.airport_name}
                              </p>
                            </Box>
                          )}
                          onChange={(event, value) => {
                            setFieldValue("Origin", value.airport_code);
                            dispatch(setSelectedOrigin(value));
                            setFrom(value);
                            // console.log(value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              onChange={handleSearchOrigin}
                              name="origin"
                            />
                          )}
                        />
                      </div>
                      <Hidden only={["xs", "sm"]}>
                        <SwapHorizontalCircleIcon
                          onClick={() => {
                            setTo(from);
                            dispatch(setSelectedOrigin(to));
                            dispatch(setSelectedDepart(from));
                            setFrom(to);
                          }}
                          style={{
                            color: "white",
                            width: "2em",
                            height: "2em",
                            marginTop: 20,
                            cursor: "pointer",
                          }}
                        />
                      </Hidden>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <div className={classes.root}>
                        <span style={{ color: "white" }}>Going To</span>
                        <Autocomplete
                          id="country-select-demo"
                          sx={{
                            background: "#eee",
                            borderRadius: "4px",
                            padding: "10px",
                            transition: "none",
                          }}
                          clearOnBlur={true}
                          options={
                            city && city.result.length > 0 ? city.result : []
                          }
                          value={to}
                          PopperComponent={PopperMy}
                          filterOptions={(options, state) => options}
                          autoHighlight
                          getOptionLabel={(option) =>
                            `${option.airport_name} (${option.airport_code}) `
                          }
                          renderOption={(props, option) => (
                            <Box
                              // mr={'5px'}
                              component="li"
                              sx={{ "& > img": { mr: 2 } }}
                              {...props}
                            >
                              <img loading="lazy" width="20" src={flt} alt="" />
                              <p style={{ fontSize: 13 }}>
                                {option.city_name} ({option.airport_code}){" "}
                                {option.airport_name}
                              </p>
                            </Box>
                          )}
                          onChange={(event, value) => {
                            setFieldValue("Destination", value.airport_code);
                            // console.log(value.airport_code);
                            dispatch(setSelectedDepart(value));
                            setTo(value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              onChange={handleSearchOrigin}
                            />
                          )}
                        />
                      </div>
                    </Grid>
                    {/* Date Picker Ending */}
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={trip == "oneway" ? 2 : trip == "roundtrip" ? 4 : 2}
                >
                  <Box display="flex" justifyContent="space-between">
                    <span style={{ color: "white" }}>Depart Date</span>
                    {trip == "oneway" ? (
                      ""
                    ) : trip == "roundtrip" ? (
                      <span style={{ color: "white" }}>Return Date</span>
                    ) : (
                      ""
                    )}
                  </Box>
                  {trip == "oneway" ? (
                    <DesktopDateNew />
                  ) : trip == "roundtrip" ? (
                    <DateRangeNew />
                  ) : (
                    <DesktopDateNew />
                  )}
                </Grid>
                {/* Travellers Strating */}
                <Grid item xs={12} md={6} lg={trip == "oneway" ? 3 : 2}>
                  <ul
                    class="menu"
                    style={{
                      marginTop: 20,
                      borderRadius: 2,
                      // width: trip == "roundtrip" ? "110%" : "95%",
                    }}
                  >
                    <li>
                      <a
                        style={{
                          padding: 12,
                          fontSize: 16,
                          borderRadius: 4,
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          fontWeight: 600,
                          backgroundColor: "#eee",
                        }}
                      >
                        Travellers,Classes
                      </a>

                      <ul style={{ padding: 5 }}>
                        <li>
                          <Box
                            style={{ padding: 5 }}
                            display="flex"
                            justifyContent="space-between"
                            textAlign="center"
                            alignItems="center"
                          >
                            <BodyText
                              four
                              textStyle={{
                                color: "black",
                                fontSize: 18,
                                fontWeight: 500,
                              }}
                            >
                              Adult
                            </BodyText>
                            <Box display="flex" alignItems="center">
                              <Box
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult === 0 ? "" : setAdult(adult - 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 18,
                                    color: "white",
                                  }}
                                >
                                  -
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                              >
                                <BodyText
                                  textStyle={{ fontSize: 17, color: "white" }}
                                >
                                  {adult}
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult + child + infant === 9
                                    ? adult
                                    : setAdult(adult + 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 17,
                                    color: "white",
                                  }}
                                >
                                  +
                                </BodyText>
                              </Box>
                            </Box>
                          </Box>
                        </li>
                        <li>
                          <Box
                            style={{ padding: 5 }}
                            display="flex"
                            justifyContent="space-between"
                            textAlign="center"
                            alignItems="center"
                          >
                            <BodyText
                              four
                              textStyle={{
                                color: "black",
                                fontSize: 18,
                                fontWeight: 500,
                              }}
                            >
                              Child
                            </BodyText>
                            <Box display="flex" alignItems="center">
                              <Box
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  child === 0 ? "" : setChild(child - 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 18,
                                    color: "white",
                                  }}
                                >
                                  -
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                              >
                                <BodyText
                                  textStyle={{ fontSize: 17, color: "white" }}
                                >
                                  {child}
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult + child + infant === 9
                                    ? child
                                    : setChild(child + 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 17,
                                    color: "white",
                                  }}
                                >
                                  +
                                </BodyText>
                              </Box>
                            </Box>
                          </Box>
                        </li>
                        <li>
                          <Box
                            style={{ padding: 5 }}
                            display="flex"
                            justifyContent="space-between"
                            textAlign="center"
                            alignItems="center"
                          >
                            <BodyText
                              four
                              textStyle={{
                                color: "black",
                                fontSize: 18,
                                fontWeight: 500,
                              }}
                            >
                              Infant
                            </BodyText>
                            <Box display="flex" alignItems="center">
                              <Box
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  infant === 0 ? "" : setInfant(infant - 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 18,
                                    color: "white",
                                  }}
                                >
                                  -
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                              >
                                <BodyText
                                  textStyle={{ fontSize: 17, color: "white" }}
                                >
                                  {infant}
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(239, 51, 57)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult + child + infant === 9
                                    ? infant
                                    : setInfant(infant + 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 17,
                                    color: "white",
                                  }}
                                >
                                  +
                                </BodyText>
                              </Box>
                            </Box>
                          </Box>
                        </li>
                        <li>
                          <Box
                            style={{ padding: 10 }}
                            display="flex"
                            justifyContent="space-between"
                          >
                            <Box className={classes.radio2}>
                              <FormControl component="fieldset">
                                <RadioGroup
                                  aria-label="gender"
                                  name="gender1"
                                  value={value}
                                  color="black"
                                  onChange={handleRadio}
                                >
                                  <FormControlLabel
                                    value="Economy"
                                    control={<Radio />}
                                    label="Economy"
                                  />
                                  <FormControlLabel
                                    value="Business"
                                    control={<Radio />}
                                    label="Business"
                                  />
                                  <FormControlLabel
                                    value="First Class"
                                    control={<Radio />}
                                    label="First Class"
                                  />
                                  <FormControlLabel
                                    value="Premium Economy"
                                    control={<Radio />}
                                    label="Premium Economy"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Box>
                          </Box>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </Grid>
                {/* Travellers Ending */}

                {/* Book Button Starting */}
                <Grid item xs={12} md={6} lg={2} style={{ marginTop: 11 }}>
                  <input
                    type="submit"
                    value="Book Now"
                    className="btn"
                    style={{
                      width: "100%",
                      fontSize: 20,
                      borderRadius: 4,
                      backgroundColor: "rgb(239, 51, 57)",
                    }}
                  />
                </Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default SearchFlight;
